<template>
  <!--
    Kundenfeedback 09.10.2026: „Bei den Telefonvermerken soll man auch
    vermerken können, ob der Gegner freundlich, unfreundlich, aufbrausend,
    verständnislos, etc. gewesen ist.“ Mehrfachauswahl plus kurze Ergänzung.
  -->
  <div class="cbf" role="group" :aria-label="$gt('Gesprächsverhalten des Gesprächspartners')">
    <span class="cbf__label">{{ $gt('Gesprächsverhalten des Gesprächspartners') }}</span>
    <v-chip-group
      :model-value="modelValue"
      class="cbf__chips"
      multiple
      column
      @update:model-value="onSelect"
    >
      <v-chip
        v-for="o in options"
        :key="o.key"
        :value="o.key"
        :color="colorOf(o)"
        :variant="isSelected(o.key) ? 'flat' : 'outlined'"
        :prepend-icon="o.icon"
        :class="['cbf__chip', `cbf__chip--${o.tone}`, { 'cbf__chip--selected': isSelected(o.key) }]"
        size="small"
        filter
      >{{ $gt(o.label) }}</v-chip>
    </v-chip-group>
    <TextField
      :model-value="note"
      :label="$gt('Ergänzung')"
      :placeholder="$gt('z. B. legte mitten im Gespräch auf')"
      :maxlength="noteMax"
      @update:model-value="$emit('update:note', $event)"
    />
  </div>
</template>

<script>
import TextField from "@/components/inputs/TextField.vue";
import {
  CONTACT_BEHAVIOR_NOTE_MAX,
  CONTACT_BEHAVIOR_OPTIONS,
  contactBehaviorColor,
  normalizeContactBehavior,
} from "@/utils/contactBehavior";

/**
 * Auswahl „Gesprächsverhalten des Gesprächspartners“ für den Telefonvermerk
 * (PhoneCallDialog) und die Gesprächsnotiz nach einem Anruf über KARS
 * (PhoneNoteSendDialog). v-model: Schlüssel, v-model:note: Ergänzung.
 */
export default {
  name: "ContactBehaviorField",
  components: { TextField },
  props: {
    modelValue: { type: Array, default: () => [] },
    note: { type: String, default: "" },
  },
  emits: ["update:modelValue", "update:note"],
  data() {
    return { options: CONTACT_BEHAVIOR_OPTIONS, noteMax: CONTACT_BEHAVIOR_NOTE_MAX };
  },
  methods: {
    isSelected(key) {
      return (this.modelValue || []).includes(key);
    },
    colorOf(o) {
      return contactBehaviorColor(o.tone);
    },
    /** Auswahl immer in kanonischer Reihenfolge melden. */
    onSelect(keys) {
      this.$emit("update:modelValue", normalizeContactBehavior(keys));
    },
  },
};
</script>

<style scoped>
.cbf { display: flex; flex-direction: column; gap: 4px; }
.cbf__label { font-size: 0.78rem; color: #64748b; }
.cbf__chips { padding: 0; }
.cbf__chip { font-weight: 500; transition: transform .12s ease, box-shadow .12s ease; }
/* Nicht gewählte Chips tragen ihre Tonlage dezent in Rahmen und Schrift. */
.cbf__chip--positive:not(.cbf__chip--selected) { color: #15803d; }
.cbf__chip--neutral:not(.cbf__chip--selected) { color: #475569; }
.cbf__chip--negative:not(.cbf__chip--selected) { color: #b91c1c; }
.cbf__chip:hover { transform: translateY(-1px); }
.cbf__chip--selected { box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18); }
.cbf__chip:focus-visible { outline: 2px solid var(--primary-color, #2563eb); outline-offset: 2px; }
</style>
